import React, { useEffect, useRef } from "react";

const CanvasAiMessages = ({ messages, status }) => {
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ block: "nearest" });
  }, [messages]);

  if (!messages.length) {
    return (
      <div className="canvas-ai-empty-state canvas-ai-empty-state--messages">
        Ask for a flowchart, architecture diagram, mind map, or an edit to the
        current canvas.
      </div>
    );
  }

  return (
    <div aria-live="polite" className="canvas-ai-messages" role="log">
      {messages.map((message) => {
        if (message.role === "notice") {
          return (
            <p className="canvas-ai-notice" key={message.id}>
              {message.content}
            </p>
          );
        }
        const className = [
          "canvas-ai-message",
          `canvas-ai-message--${message.role}`,
          message.isError ? "canvas-ai-message--error" : "",
        ]
          .filter(Boolean)
          .join(" ");
        return (
          <div className={className} key={message.id}>
            {message.content || (status === "streaming" ? "Thinking…" : "")}
          </div>
        );
      })}
      <span ref={endRef} />
    </div>
  );
};

export default CanvasAiMessages;
